import React from 'react';
import {
  Box,
  useColorModeValue,
  Drawer,
  DrawerContent,
  useDisclosure,
} from '@chakra-ui/react';
import { FiHome, FiCompass, FiSettings, FiUser, FiMessageSquare } from 'react-icons/fi';
import { FaRobot } from 'react-icons/fa';
import SidebarContent from 'components/Layout/SidebarContent';
import NavBar from 'components/Layout/NavBar';
import { APP_ROUTES } from '_app/routes';

const LINK_ITEMS = [
  { name: 'Home', to: APP_ROUTES.HOME, icon: FiHome },
  { name: 'Bots', to: APP_ROUTES.BOTS, icon: FaRobot },
  { name: 'User', to: APP_ROUTES.USERS, icon: FiUser },
  { name: 'Messages', to: APP_ROUTES.MESSAGES, icon: FiMessageSquare },
  { name: 'Posts', to: APP_ROUTES.POSTS, icon: FiMessageSquare },
  // { name: 'Settings', to: APP_ROUTES.SETTINGS, icon: FiSettings },
  // { name: 'User Roles', to: APP_ROUTES.ROLES.INDEX, icon: FiUser },
];

const Layout = ({ children }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Box
      minH="100vh"
      bg={useColorModeValue('gray.100', 'gray.900')}
      overflowX="auto"
    >
      <SidebarContent
        linkItems={LINK_ITEMS}
        onClose={() => onClose}
        display={{ base: 'none', md: 'block' }}
      />
      <Drawer
        autoFocus={false}
        isOpen={isOpen}
        placement="left"
        onClose={onClose}
        returnFocusOnClose={false}
        onOverlayClick={onClose}
        size="full"
      >
        <DrawerContent>
          <SidebarContent linkItems={LINK_ITEMS} onClose={onClose} />
        </DrawerContent>
      </Drawer>
      <NavBar onOpen={onOpen} />
      <Box ml={{ base: 0, md: 60 }} p="4">
        {children}
      </Box>
    </Box>
  );
};

export default Layout;
